module.exports = __webpack_public_path__ + "img/7.8ec720e4.png";